<template>
  <q-page>
    <div v-if="$apollo.loading">Loading...</div>
    <q-table v-else title="Accounts" :columns="columns" :data="productColours" :pagination.sync="pagination" flat :filter="filter" binary-state-sort>
      <template v-slot:top>
        <q-space />
        <q-input dense debounce="300" color="primary" v-model="filter">
          <template v-slot:append>
            <q-icon name="search" />
          </template>
        </q-input>
      </template>

      <template v-slot:body-cell-hex="props">
        <q-td :props="props">
          <div :style="{border: '1px solid silver', backgroundColor: props.value, width: '25px',height: '25px'}">
            <q-tooltip>{{props.value}}</q-tooltip>
          </div>
        </q-td>
      </template>

    </q-table>
  </q-page>
</template>

<script>
import moment from 'moment'
import gql from 'graphql-tag'

export default {
  name: 'PageAdminColours',
  apollo: {
    productColours: {
      query: gql`
        query fetchProductColours {
          productColours
        }
      `,
      deep: true,
      fetchPolicy: 'network-only',
      update (result) {
        return result.productColours.map(colour => JSON.parse(colour))
      }
    }
  },
  methods: {
    fromNow (t) {
      if (!t) return 'Unknown'
      return moment(t).fromNow()
    },
    deleteAccount (account) {
      this.$q.dialog({
        title: 'Delete Account',
        message: `Are you sure you want to delete ${account.companyName}?`,
        cancel: true
      }).onOk(() => {
        // this.deleteCartItem(item)
        console.log('implement delete!')
      })
    }
  },
  data () {
    return {
      filter: '',
      columns: [
        { name: 'hex', align: 'left', required: true, label: 'Hex', field: 'hex', sortable: true },
        { name: 'superGroup', align: 'left', required: true, label: 'Super Group', field: 'superGroup', sortable: true },
        { name: 'group', align: 'left', required: true, label: 'Group', field: 'group', sortable: true },
        { name: 'name', align: 'left', required: true, label: 'Name', field: 'name', sortable: true },
        { name: 'ralName', align: 'left', required: true, label: 'RAL', field: 'ralName', sortable: true },
        { name: 'pantoneName', align: 'left', required: true, label: 'Pantone', field: 'pantoneName', sortable: true },
        { name: 'aragonName', align: 'left', required: true, label: 'Aragon Name', field: 'aragonName', sortable: true },
        { name: 'compxName', align: 'left', required: true, label: 'Composite X Name', field: 'compxName', sortable: true }
      ],
      pagination: {
        rowsPerPage: 0
      }
    }
  }
}
</script>
